export function cleanName(name) {
    const hasTrailingSpace = /\s$/.test(name);
    name = name.replace(/[^а-яА-ЯёЁa-zA-Z\s\-]/g, '');
    name = name.replace(/\s+/g, ' ').trim();
    name = name.split(' ').map(word =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ');
    if (hasTrailingSpace) {
        name += ' ';
    }
    return name;
}
